import { updateLinksAttributes } from '../utils/handleAttributes';

export default function headerCustomButtons(widgetNameVariable, widgetOptsVariable) {
  const widgetName = widgetNameVariable;
  const $widget = $(`#${widgetName}`);
  const widgetOpts = widgetOptsVariable;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomTicketBtn(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomTicketBtn(widgetData) {
    const { Title, URL } = widgetData.items[0];

    if (URL == null) {
      $widget.remove();
    } else {
      $widget.find('.card-widget-item').replaceWith(
        `<a class="btn-wrap" tabindex="0" href="${URL}" ${updateLinksAttributes(URL, Title)}>
            <span class="btn-label">${Title}</span>
          </a>`,
      );
    }
  }
}
